import React, { useEffect, useState } from "react";
import api from "../../utils/api";

export default function StaticContentPage({ title, contentKey, fallbackContent }) {
  const [content, setContent] = useState(fallbackContent);

  useEffect(() => {
    let active = true;

    const fetchContent = async () => {
      try {
        const { data } = await api.get("/settings/content");
        const nextContent = data.settings?.[contentKey];

        if (active && typeof nextContent === "string" && nextContent.trim()) {
          setContent(nextContent);
        }
      } catch (error) {
        console.error(`Error fetching ${contentKey}:`, error);
      }
    };

    fetchContent();

    return () => {
      active = false;
    };
  }, [contentKey]);

  return (
    <div className="container mx-auto px-4 py-16">
      <h1 className="heading-metallic text-4xl mb-6">{title}</h1>
      <div
        className="prose prose-invert max-w-none text-gray-300 [&_h2]:heading-metallic-soft [&_h2]:text-2xl [&_h2]:mt-6"
        dangerouslySetInnerHTML={{ __html: content }}
      />
    </div>
  );
}